/* eslint-disable @typescript-eslint/naming-convention */
import { getFileExtension } from '../common';

/**
 * MIME type sources used:
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
 * https://www.digipres.org/formats/mime-types/
 */
export const MIME_TYPE_MAP: { [key: string]: string } = {
    ai: 'application/illustrator',
    avi: 'video/avi',
    csv: 'text/csv',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    eot: 'application/vnd.ms-fontobject',
    eps: 'application/postscript',
    gif: 'image/gif',
    heic: 'image/heic',
    heif: 'image/heif',
    htm: 'text/html',
    html: 'text/html',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    m4v: 'video/mp4',
    mov: 'video/quicktime',
    mp3: 'audio/mpeg3',
    mp4: 'video/mp4',
    otf: 'font/otf',
    pdf: 'application/pdf',
    png: 'image/png',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    psd: 'image/vnd.adobe.photoshop',
    ttf: 'font/ttf',
    txt: 'text/plain',
    wav: 'audio/wav',
    webp: 'image/webp',
    woff: 'application/x-font-woff',
    woff2: 'application/x-font-woff2',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip',
};

export const THUMBNAIL_FILE_PATH_MAP: { [key: string]: string } = {
    'application/illustrator': '/img/thumbnail-ai.svg',
    'application/msword': '/img/thumbnail-doc.svg',
    'application/pdf': '/img/thumbnail-pdf.svg',
    'application/postscript': '/img/thumbnail-eps.svg',
    'application/vnd.ms-excel': '/img/thumbnail-xls.svg',
    'application/vnd.ms-powerpoint': '/img/thumbnail-ppt.svg',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': '/img/thumbnail-ppt.svg',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/img/thumbnail-xls.svg',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '/img/thumbnail-doc.svg',
    'application/zip': '/img/thumbnail-zip.svg',
    'audio/mpeg3': '/img/thumbnail-mp3.svg',
    'audio/wav': '/img/thumbnail-wav.svg',
    'image/gif': '/img/thumbnail-gif.svg',
    'image/jpeg': '/img/thumbnail-jpg.svg',
    'image/png': '/img/thumbnail-png.svg',
    'image/vnd.adobe.photoshop': '/img/thumbnail-psd.svg',
    'text/csv': '/img/thumbnail-csv.svg',
    'text/html': '/img/thumbnail-html.svg',
    'text/plain': '/img/thumbnail-txt.svg',
    'video/avi': '/img/thumbnail-avi.svg',
};

export function getThumbnailFilePath(mimeType: string): string {
    if (mimeType in THUMBNAIL_FILE_PATH_MAP) {
        return THUMBNAIL_FILE_PATH_MAP[mimeType];
    } else {
        return '/img/thumbnail-other.svg';
    }
}

export function getThumbnailFilePathUsingFileName(fileNameOrExtension: string): string {
    return getThumbnailFilePath(getMimeType(fileNameOrExtension));
}

export function getMimeType(fileNameOrExtension?: string, defaultType = 'application/octet-stream'): string {
    let mimeType: string | undefined;
    if (fileNameOrExtension) {
        const ext = getFileExtension(fileNameOrExtension).toLowerCase();
        mimeType = MIME_TYPE_MAP[ext];
    }
    if (!mimeType) {
        mimeType = defaultType;
    }
    return mimeType;
}

export function getGeneralMimeType(fileNameOrExtension: string): string {
    const mime = getMimeType(fileNameOrExtension);
    return mime.split('/')[0];
}

export function getFileExtensionUsingMimeType(mimeType: string): string | undefined {
    for (const extension in MIME_TYPE_MAP) {
        if (mimeType === MIME_TYPE_MAP[extension]) {
            return extension;
        }
    }
    return undefined;
}
